var map = {
	"./background.jpg": [
		366,
		7,
		5
	],
	"./bar.jpg": [
		367,
		7,
		6
	],
	"./bevande.jpg": [
		368,
		7,
		7
	],
	"./birre.jpg": [
		369,
		7,
		8
	],
	"./dolci.jpg": [
		370,
		7,
		9
	],
	"./fritti.jpg": [
		371,
		7,
		10
	],
	"./hamburger.jpg": [
		372,
		7,
		11
	],
	"./heineken.svg": [
		373,
		9,
		3
	],
	"./home.jpg": [
		374,
		7,
		12
	],
	"./logo.svg": [
		375,
		9,
		4
	],
	"./maps.png": [
		376,
		7,
		13
	],
	"./messina-cristalli-di-sale.png": [
		377,
		7,
		14
	],
	"./moretti-grand-cru.png": [
		378,
		7,
		15
	],
	"./moretti-grani-antichi.png": [
		379,
		7,
		16
	],
	"./moretti-larossa.png": [
		380,
		7,
		17
	],
	"./moretti-lunga-maturazione.png": [
		381,
		7,
		18
	],
	"./panini.jpg": [
		382,
		7,
		19
	],
	"./piatti.jpg": [
		383,
		7,
		20
	],
	"./pizza.jpg": [
		384,
		7,
		21
	],
	"./sandwich.jpg": [
		385,
		7,
		22
	],
	"./staff.jpg": [
		386,
		7,
		23
	],
	"./watneys-scotch-blue-beer.png": [
		387,
		7,
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 219;
module.exports = webpackAsyncContext;